/**
 * Utility functions for parts manipulation
 */

/**
 * Get all parts from partsByType, sorted and deduplicated
 */
export const getAllPartsFromText = (text) => {
  const seenIds = new Set();

  return Object.entries(text?.partsByType || {})
    .sort(([, a], [, b]) => (a.order || 9999) - (b.order || 9999))
    .flatMap(([typeName, typeData]) =>
      typeData.parts
        .map((part, index) => ({
          ...part,
          typeName,
          indexInType: index,
        }))
        .filter((partObj) => {
          if (!partObj.id) return true;
          if (seenIds.has(partObj.id)) return false;
          seenIds.add(partObj.id);
          return true;
        })
    );
};

/**
 * Get current global index for selected part
 */
export const getCurrentGlobalIndex = (allParts, selectedContentId) => {
  return allParts.findIndex((p) => p.id === selectedContentId);
};

/**
 * Extract selected part name from selectedContent
 */
export const extractSelectedPartName = (selectedContent) => {
  const content = selectedContent?.content?.trim();

  if (typeof content === "string") {
    const noQty = content.split(" - Qty-")[0].trim();
    const parts = noQty.split(" ");

    if (
      parts.length > 1 &&
      (selectedContent?.unit || selectedContent?.part?.unit)
    ) {
      parts.pop();
      return parts.join(" ").trim();
    }
    return noQty;
  }

  return selectedContent?.part?.part?.trim() || "";
};

/**
 * Create selected content object from part
 */
export const createSelectedContentFromPart = (part, typeName) => {
  return {
    type: "part",
    id: part.id,
    content: `${part.part} - Qty-${part.qty} ${part.unit}`,
    index: part.indexInType,
    part: part,
    qty: part.qty,
    unit: part.unit,
    typeKey: typeName || part.typeName,
    part_ref: part.part_ref,
    unit_type_id: part.unit_type_id,
  };
};
